module.exports = __webpack_public_path__ + "img/blue_vip.fc0d13d3.png";